var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 15",
    style: {
      enableBackground: "new 0 0 17 15"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.7,2.4C13.3,1,11,1,9.6,2.4L8.5,3.5L7.4,2.4C6,1,3.7,1,2.3,2.4s-1.4,3.7,0,5.1l6.2,6.2l6.2-6.2 C16.1,6.1,16.1,3.8,14.7,2.4z",
    fill: "none",
    stroke: "#717375",
    strokeWidth: 0.5365
  })));
}

export default SvgHeart;